export default __webpack_public_path__ + "static/media/28.8a733970.mp3";